import { TableHeader } from "@/components/table"
import { DisplaySortIcon } from "@/domains/pools/components/display-sort-icon"
import { Sort } from "@/domains/table-processor"

export const ThWalletBalanceValueUsd = ({ setSortBy, sortBy }: { setSortBy: (v: Sort) => void; sortBy: Sort }) => {
  return (
    <TableHeader
      className="text-right"
      classNameInner="justify-end"
      onClick={() => {
        setSortBy({
          key: "walletValueUSD",
          direction: sortBy.direction === "asc" ? "desc" : "asc",
          type: "number",
        })
      }}
    >
      Wallet
      <DisplaySortIcon sortBy={sortBy} column="walletValueUSD" />
    </TableHeader>
  )
}
